const RecordsManagement = () => {
    return (
      <div>
          
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

            <div className="px-1 flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Records Management
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                TCS Warehousing systems cater to the businesses in need to manage the continuous relay of information 
                from multiple locations to track real-time locations, supply chain controls, delivery and order 
                fulfilment information.
                </p>
               <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                By removing the enormous scope for errors, mishandling of information and the lack of availability 
                to latest information, shipment of your deliveries improve. This helps to minimise upsetting customers 
                and losing their trust.
              </p>
             
            </div>
            <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
              <img src="/warehousing/Records-Management-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
            </div>
          </ div>

        </div>

      </div>
    );
  };
  
  export default RecordsManagement;
  